angular.module('contactModule').component('managementSection', {
	templateUrl: 'managementSection/managementSection.html',
	bindings: {
		firm: '<',
		user: '<', 
		isMobile: '@'
	},
	controller:[function() {
		var ctrl = this;
	}]
}); 